(function () {
    'use strict';

    angular.module("imApp").factory("productLabelService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3438,
                    parameters: parms || {}
                });
            },
            listReports: function (parms) {
                return $ihttp.post({
                    method: 335,
                    parameters: parms || {}
                });
            },
            changeProductId: function (edit) {
                return $ihttp.post({
                    method: 3441,
                    parameters: edit
                });
            },
            printObj: function (edit) {
                return $ihttp.post({
                    method: 3439,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
